import React from 'react';
import LandlordToolkitLayout from '../../components/landlord-toolkit/LandlordToolkitLayout';
import MessagesPage from './MessagesPage';

const LandlordToolkitMessagesPage: React.FC = () => {
  return (
    <LandlordToolkitLayout title="Rental Resources">
      <div className="w-full">
        <MessagesPage />
      </div>
    </LandlordToolkitLayout>
  );
};

export default LandlordToolkitMessagesPage;
